import { useMemo } from 'react';
import { calculateRouteTimeByProviders } from '@lp/features/MultiSuggest/utils';
import { AircraftIcon } from '@icons';
import { DeviationInfo } from '@lp/features/MultiSuggest/components/MultiSuggestResult/DeviationInfo';
import { AviaLegTypes, GroundLegTypes, RouteLegTypeEnum } from '@/api/apis/route';
import { msToFixedHours } from '@/utils/helpers';

type SuggestedProviderTimeValueProps = {
  title: string;
  currentLegs: (AviaLegTypes | GroundLegTypes)[];
  suggestedLegs: (AviaLegTypes | GroundLegTypes)[];
};

export const SuggestedProviderTimeValue = ({ title, currentLegs, suggestedLegs }: SuggestedProviderTimeValueProps) => {
  const currentTmdxJetTimeValue = useMemo(() => {
    return calculateRouteTimeByProviders(currentLegs, [RouteLegTypeEnum.TmdxJetAviaLeg])[0];
  }, [currentLegs]);

  const suggestedProvider = useMemo(() => {
    return calculateRouteTimeByProviders(suggestedLegs, [RouteLegTypeEnum.TmdxJetAviaLeg])[0];
  }, [suggestedLegs]);

  const deviation = useMemo(() => {
    if (!currentTmdxJetTimeValue) return null;

    const suggestedTimeInMs = suggestedProvider?.timeInMs || 0;
    const isNegative = currentTmdxJetTimeValue.timeInMs > suggestedTimeInMs;
    const diff = Math.abs(currentTmdxJetTimeValue.timeInMs - suggestedTimeInMs);

    return {
      isNegative,
      diff,
    };
  }, [currentTmdxJetTimeValue, suggestedProvider]);

  if (!currentTmdxJetTimeValue) return null;

  return (
    <div className="flex flex-wrap gap-2 items-center">
      <span className="text-m-cps text-base-30 mr-2">{title}</span>
      <div className="flex flex-wrap items-center gap-2">
        <div className="flex items-center gap-1">
          <AircraftIcon />
          {suggestedProvider && (
            <span className="text-m-sb text-black">{msToFixedHours(suggestedProvider.timeInMs)}</span>
          )}
          {deviation && <DeviationInfo value={msToFixedHours(deviation.diff)} isNegative={deviation.isNegative} />}
        </div>
      </div>
    </div>
  );
};
